import { FC, useEffect, useState } from 'react';
import { Search } from 'lucide-react';

import { Input } from '@/components/ui/input';
import { useDebounce } from '@/hooks/use-debounce';

interface GraphSearchInputProps {
  initialValue: string;
  onQueryChange: (query: string) => void;
}

// Owns the raw keystroke state so typing re-renders this one input instead of
// the whole SVG scene; only the debounced query reaches the parent.
export const GraphSearchInput: FC<GraphSearchInputProps> = ({
  initialValue,
  onQueryChange,
}) => {
  const [value, setValue] = useState(initialValue);
  const debounced = useDebounce(value, 200);

  useEffect(() => {
    onQueryChange(debounced);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debounced]);

  return (
    <Input
      value={value}
      onChange={(event) => setValue(event.target.value)}
      placeholder='Search entities & facts…'
      icon={Search}
      className='bg-background/85 h-8 backdrop-blur-sm md:text-xs'
      aria-label='Search graph'
    />
  );
};
